import { ROOT_TYPES, PARENT_TYPES } from "@/types/containerTypes";
import { Block } from "../models/block";
import { Container } from "../models/containers/container";
import { ProcedureInstanceBase } from "../models/procedureInstances/procedureInstanceBase";
import { ImplementationFunction } from "../models/implementationFunction";

export function getRootId(parent: Container | Block | ProcedureInstanceBase | ImplementationFunction) {
  if (parent instanceof Container) {
    return parent.rootId;
  }
  if (parent instanceof Block || parent instanceof ProcedureInstanceBase || parent instanceof ImplementationFunction) {
    return parent.id;
  }
  throw new Error('Parent is not a container or block');
}

export function getRootType(parent: Container | Block | ProcedureInstanceBase | ImplementationFunction) {
  if (parent instanceof Container) {
    return parent.rootType;
  }

  if (parent instanceof Block) {
    return ROOT_TYPES.BLOCK;
  }

  if (parent instanceof ImplementationFunction) {
    return ROOT_TYPES.IMPLEMENTATION_FUNCTION;
  }

  if (parent instanceof ProcedureInstanceBase) {
    return ROOT_TYPES.PROCEDURE;
  }

  throw new Error('Parent is not a container or block');
}

export function getParentType(parent: Container | Block | ProcedureInstanceBase | ImplementationFunction) {
  if (parent instanceof Container) {
    return PARENT_TYPES.CONTAINER;
  }
  if (parent instanceof Block) {
    return PARENT_TYPES.BLOCK;
  }

  if (parent instanceof ImplementationFunction) {
    return PARENT_TYPES.IMPLEMENTATION_FUNCTION;
  }

  if (parent instanceof ProcedureInstanceBase) {
    return PARENT_TYPES.PROCEDURE;
  }

  throw new Error('Parent is not a container or block');
}